import React from "react";

const NavigationDots = ({ active }) => {
  return (
    <div className="app__navigation">
      <ul>
        {["home", "about", "work", "skills", "testimonials", "contact"].map(
          (item, index) => {
            return (
              <a key={item + index} href={`#${item}`}>
                <div
                  style={active === item ? { backgroundColor: "#313BAC" } : {}}
                  className="app__navigation-dot"
                ></div>
              </a>
            );
          }
        )}
      </ul>
    </div>
  );
};

export default NavigationDots;
